import React from 'react';
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from 'react-router-dom';

import { ReduxProvider } from '@tmapy/redux';
import { IntlProvider } from '@tmapy/intl';
import { DevToolsContainer } from '@tmapy/devtools';

import '@tmapy/style-guide/dist/sass/_global.scss';
import './overrides.scss';
import './utils.scss';

import { BASENAME } from '../constants';
import { routes } from '../routes';
import { Error, ERROR_TYPE } from './components/Error';
import { ErrorBoundary, renderDefaultError } from './components/ErrorBoundary';

const router = createBrowserRouter(
  createRoutesFromElements(
    <React.Fragment>
      {routes.map(({ id, element, path }) => (
        <Route key={id} path={path} element={element} />
      ))}
      <Route path='*' element={<Error type={ERROR_TYPE.NOT_FOUND} />} />
    </React.Fragment>,
  ),
  { basename: BASENAME },
);

export const App: React.FC = () => {
  return (
    <ReduxProvider>
      <IntlProvider>
        <DevToolsContainer />
        <ErrorBoundary fallback={renderDefaultError}>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </IntlProvider>
    </ReduxProvider>
  );
};
